import { inview } from "./assets/js/modules/inview.js";
import { hambergerToggle } from "./assets/js/modules/hamburgertoggle.js";
import { pageTopBtnAction } from "./assets/js/modules/pagetopbtn-action.js";
import { headerAction } from "./assets/js/modules/header-action.js";
import { accordion } from "./assets/js/modules/accordion.js";
import { initPcNav } from "./assets/js/modules/pcNav.js";
import { spNavDropToggle } from "./assets/js/modules/spDropToggle.js";
import { resizeAction } from "./assets/js/modules/resize-action.js";
import { cookie } from "./assets/js/modules/cookie.js";
import { loadingAni } from "./assets/js/modules/loadding-ani.js";
import { topChart } from "./assets/js/modules/top-chart.js";
import { memberSlider } from "./assets/js/modules/member-slider.js";
import { tabBtn } from "./assets/js/modules/tab-btn.js";
import { formPlvacyPolicy } from "./assets/js/modules/form-privacypolicy.js";
import { InvestItemInit } from "./assets/js/modules/rating.js";
import { data } from "./assets/js/modules/data.js";

const $body = $("body");

spNavDropToggle();
initPcNav();
inview();
hambergerToggle();
pageTopBtnAction();
headerAction();
accordion();
cookie();

if ($body.hasClass("top")) {
  loadingAni();
  topChart();
  memberSlider();
  resizeAction();
}

if ($body.hasClass("interview")) {
  memberSlider();
  resizeAction();
}

if ($body.hasClass("information")) {
  tabBtn();
}

if ($body.hasClass("entry")) {
  formPlvacyPolicy();
}

InvestItemInit();
data();